import { useDispatch, useSelector } from "react-redux";
import { toast } from "@/components/ui/use-toast";
import {
  fetchMessages,
  fetchSellerById,
  updateIsRead
} from "../../store/partChat/partChatActions";
import { openAuthDialog } from "../../store/auth/authSlice";
import { removeSavedPart, savePart } from "../../store/parts/partsAction";

export const usePartOperation = () => {
  const dispatch = useDispatch();
  const { user, isAuthenticated } = useSelector((state) => state.auth);
  const { savedParts } = useSelector((state) => state.parts);

  const handleChatClick = async (part, onConversationSet) => {
    if (!isAuthenticated || !user) {
      toast({
        title: "Login Required",
        description: "Please login to send a message to Seller.",
        variant: "destructive"
      });
      dispatch(
        openAuthDialog({
          showLoginFirstOrOnSuccess: true
        })
      );
      return;
    }

    try {
      const sellerData = await dispatch(
        fetchSellerById({ userId: part?.sellerId })
      ).unwrap();

      const conversation = {
        partInfo: part,
        otherUserDetail: sellerData
      };

      dispatch(
        fetchMessages({
          buyerId: user?.uid,
          sellerId: part?.sellerId,
          partId: part?.id,
          currentUserId: user?.uid
        })
      );

      setTimeout(() => {
        dispatch(
          updateIsRead({
            currentUserId: user?.uid,
            receiverId: part?.sellerId,
            partId: part?.id
          })
        );
      }, 1000);

      onConversationSet(conversation);
    } catch (error) {
      console.error("❌ Failed to fetch seller:", error);
      toast({
        title: "Error",
        description: "Failed to start chat. Please try again.",
        variant: "destructive"
      });
    }
  };

  const handleSaveClick = (part) => {
    if (!isAuthenticated || !user) return;

    const isSaved = savedParts?.some(
      (saved) => saved.partId === part?.id && saved.userId === user?.uid
    );

    if (isSaved) {
      dispatch(removeSavedPart({ userId: user?.uid, partId: part?.id }));
    } else {
      dispatch(savePart({ userId: user?.uid, part: part }));
    }
  };

  return {
    handleChatClick,
    handleSaveClick,
    isAuthenticated,
    user
  };
};
